import React from "react";
import { Modal, Row, Col, Collapse } from "antd";
import Card from "../../Cards/RegisteredTeamModalCard";

const { Panel } = Collapse;

const App = ({ modalVisible, setModalVisible, teams }) => {
  const normalRegisteredTeams = teams?.filter((team) => !team?.wildCard);
  const wildCardRegisteredTeams = teams?.filter((team) => team?.wildCard);

  // Group wild cards by wildCard ID
  const groupedWildCards = Object.groupBy(
    wildCardRegisteredTeams || [],
    (team) => team?.wildCard?._id
  );

  return (
    <React.Fragment>
      <Modal
        visible={modalVisible}
        onCancel={() => {
          setModalVisible(false);
        }}
        width={1000}
        style={{
          top: 20
        }}
        className="modalRadius"
        closable={false}
        destroyOnClose
        footer={false}>
        <h2
          style={{
            textAlign: "center",
            fontWeight: "700",
            userSelect: "none",
            marginTop: "10px",
            marginBottom: "20px"
          }}>
          Registered Teams
        </h2>

        <Collapse className="mb-5">
          {normalRegisteredTeams?.length > 0 && (
            <Panel header="Normal Registered Teams" key="1">
              <Row justify="space-evenly">
                {normalRegisteredTeams?.map((e, i) => (
                  <Col key={i} lg={7} md={11} sm={24} xs={24}>
                    <Card team={e} />
                  </Col>
                ))}
              </Row>
            </Panel>
          )}

          {Object.entries(groupedWildCards).map(([wildCardId, teams], index) => (
            <Panel header={`Wild Card Group ${index + 1}`} key={`wildcard-${wildCardId}`}>
              <Row justify="space-evenly">
                {teams.map((e, i) => (
                  <Col key={i} lg={7} md={11} sm={24} xs={24}>
                    <Card team={e} />
                  </Col>
                ))}
              </Row>
            </Panel>
          ))}
        </Collapse>
      </Modal>
    </React.Fragment>
  );
};

export default App;
